export default __webpack_public_path__ + "static/media/[RGB] BOX2HELP-crvena.648cb5be.png";